/* tslint:disable */
/* eslint-disable */
/**
 * Bank Backoffice Gateway Cards. External.
 * Bank Backoffice Gateway Cards. External.
 *
 * The version of the OpenAPI document: 5.0
 * Contact: radomil.janicek@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Address of the customer.
 * @export
 * @interface AddressV5
 */
export interface AddressV5 {
    /**
     * Street.
     * @type {string}
     * @memberof AddressV5
     */
    'street'?: string;
    /**
     * City.
     * @type {string}
     * @memberof AddressV5
     */
    'city': string;
    /**
     * ZIP code.
     * @type {string}
     * @memberof AddressV5
     */
    'zipcode': string;
    /**
     * Country.
     * @type {string}
     * @memberof AddressV5
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface AmountIsoCurrencyV2x0
 */
export interface AmountIsoCurrencyV2x0 {
    /**
     * 
     * @type {number}
     * @memberof AmountIsoCurrencyV2x0
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof AmountIsoCurrencyV2x0
     */
    'currencyCode': string;
}
/**
 * 
 * @export
 * @interface BackofficeAccountForCardListResponseV5
 */
export interface BackofficeAccountForCardListResponseV5 {
    /**
     * Unique identifier for the bank account.
     * @type {string}
     * @memberof BackofficeAccountForCardListResponseV5
     */
    'accountUuid': string;
    /**
     * The name of the bank account.
     * @type {string}
     * @memberof BackofficeAccountForCardListResponseV5
     */
    'name': string;
    /**
     * IBan
     * @type {string}
     * @memberof BackofficeAccountForCardListResponseV5
     */
    'iban': string;
    /**
     * Account product code.
     * @type {string}
     * @memberof BackofficeAccountForCardListResponseV5
     */
    'productCode': string;
}
/**
 * Card action item.
 * @export
 * @interface CardActionItem2V5
 */
export interface CardActionItem2V5 {
    /**
     * UUID of the card.
     * @type {string}
     * @memberof CardActionItem2V5
     */
    'bankCardUuid'?: string;
    /**
     * UUID of the card holder.
     * @type {string}
     * @memberof CardActionItem2V5
     */
    'pidUuid': string;
    /**
     * 
     * @type {CardActionTypeV5}
     * @memberof CardActionItem2V5
     */
    'type': CardActionTypeV5;
    /**
     * 
     * @type {CardActionStatus2V5}
     * @memberof CardActionItem2V5
     */
    'status': CardActionStatus2V5;
    /**
     * Date when the action was initialized.
     * @type {string}
     * @memberof CardActionItem2V5
     */
    'actionInitializedAt': string;
    /**
     * Error message of the action.
     * @type {string}
     * @memberof CardActionItem2V5
     */
    'errorMessage'?: string;
    /**
     * Date when the action was processed.
     * @type {string}
     * @memberof CardActionItem2V5
     */
    'processedAt'?: string;
    /**
     * Request trace UUID of the action.
     * @type {string}
     * @memberof CardActionItem2V5
     */
    'requestTraceUuid'?: string;
    /**
     * Creation date of the action.
     * @type {string}
     * @memberof CardActionItem2V5
     */
    'createdAt': string;
    /**
     * Last update date of the action.
     * @type {string}
     * @memberof CardActionItem2V5
     */
    'updatedAt': string;
}


/**
 * Card action item.
 * @export
 * @interface CardActionItemV5
 */
export interface CardActionItemV5 {
    /**
     * UUID of the card.
     * @type {string}
     * @memberof CardActionItemV5
     */
    'bankCardUuid': string;
    /**
     * UUID of the card holder.
     * @type {string}
     * @memberof CardActionItemV5
     */
    'pidUuid': string;
    /**
     * 
     * @type {CardActionTypeV5}
     * @memberof CardActionItemV5
     */
    'type': CardActionTypeV5;
    /**
     * 
     * @type {CardActionStatusV5}
     * @memberof CardActionItemV5
     * @deprecated
     */
    'status': CardActionStatusV5;
    /**
     * Date when the action was initialized.
     * @type {string}
     * @memberof CardActionItemV5
     */
    'actionInitializedAt': string;
    /**
     * Error message of the action.
     * @type {string}
     * @memberof CardActionItemV5
     */
    'errorMessage'?: string;
    /**
     * Date when the action was processed.
     * @type {string}
     * @memberof CardActionItemV5
     */
    'processedAt'?: string;
    /**
     * Request trace UUID of the action.
     * @type {string}
     * @memberof CardActionItemV5
     */
    'requestTraceUuid'?: string;
    /**
     * Creation date of the action.
     * @type {string}
     * @memberof CardActionItemV5
     */
    'createdAt': string;
    /**
     * Last update date of the action.
     * @type {string}
     * @memberof CardActionItemV5
     */
    'updatedAt': string;
}


/**
 * Status of the action:   - `PENDING` - action is waiting for processing  - `PROCESSING` - action is being processed  - `PROCESSING_IN_VISA` - request is being processed in VISA  - `SUCCESS` - action was successfully processed  - `FAILED` - action processing failed  - `OBSOLETE` - action is obsolete, won\'t be processed 
 * @export
 * @enum {string}
 */

export const CardActionStatus2V5 = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    PROCESSING_IN_VISA: 'PROCESSING_IN_VISA',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    OBSOLETE: 'OBSOLETE'
} as const;

export type CardActionStatus2V5 = typeof CardActionStatus2V5[keyof typeof CardActionStatus2V5];


/**
 * Status of the action:   - `PENDING` - action is waiting for processing  - `PROCESSING` - action is being processed  - `SUCCESS` - action was successfully processed  - `FAILED` - action processing failed  - `OBSOLETE` - action is obsolete, won\'t be processed 
 * @export
 * @enum {string}
 */

export const CardActionStatusV5 = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    OBSOLETE: 'OBSOLETE'
} as const;

export type CardActionStatusV5 = typeof CardActionStatusV5[keyof typeof CardActionStatusV5];


/**
 * Type of the card action: - `CREATE` - card was created automatically  - `BLOCK` - card was blocked automatically  - `UNBLOCK` - card was unblocked automatically - `TERMINATE` - card was terminated automatically - `CUSTOMER_UPDATE` - customer data was updated (phone, email,..) - `CUSTOMER_TERMINATE` - customer was terminated - `ADDRESS_UPDATE` - address was updated - `CUSTOMER_OPT_IN` - customer manually opted in - `CUSTOMER_OPT_OUT` - customer manually opted out 
 * @export
 * @enum {string}
 */

export const CardActionTypeV5 = {
    CREATE: 'CREATE',
    BLOCK: 'BLOCK',
    UNBLOCK: 'UNBLOCK',
    TERMINATE: 'TERMINATE',
    CUSTOMER_UPDATE: 'CUSTOMER_UPDATE',
    CUSTOMER_TERMINATE: 'CUSTOMER_TERMINATE',
    ADDRESS_UPDATE: 'ADDRESS_UPDATE',
    CUSTOMER_OPT_IN: 'CUSTOMER_OPT_IN',
    CUSTOMER_OPT_OUT: 'CUSTOMER_OPT_OUT'
} as const;

export type CardActionTypeV5 = typeof CardActionTypeV5[keyof typeof CardActionTypeV5];


/**
 * Request with card actions list filter, which uses AND logic for filter\'s fields and by default it is sorted DESC by created at.
 * @export
 * @interface CardActionsListRequest2V5
 */
export interface CardActionsListRequest2V5 {
    /**
     * 
     * @type {CardActionTypeV5}
     * @memberof CardActionsListRequest2V5
     */
    'type'?: CardActionTypeV5;
    /**
     * Filter card actions which were initialized after given date. Greater or equal.
     * @type {string}
     * @memberof CardActionsListRequest2V5
     */
    'actionInitializedAfterInclusive'?: string;
    /**
     * 
     * @type {CardActionStatus2V5}
     * @memberof CardActionsListRequest2V5
     */
    'status'?: CardActionStatus2V5;
    /**
     * Filter card actions which have given error message. Like case insensitive.
     * @type {string}
     * @memberof CardActionsListRequest2V5
     */
    'errorMessage'?: string;
    /**
     * Filter card actions which were processed after given date. Greater or equal.
     * @type {string}
     * @memberof CardActionsListRequest2V5
     */
    'processedAfterInclusive'?: string;
    /**
     * Filter card actions which were started processing after given date. Greater or equal.
     * @type {string}
     * @memberof CardActionsListRequest2V5
     */
    'startProcessAfterInclusive'?: string;
    /**
     * Filter card actions via request trace UUID. Equal.
     * @type {string}
     * @memberof CardActionsListRequest2V5
     */
    'requestTraceUuid'?: string;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof CardActionsListRequest2V5
     */
    'pageable': PageableV1x0;
}


/**
 * Request with card actions list filter, which uses AND logic for filter\'s fields and by default it is sorted DESC by created at.
 * @export
 * @interface CardActionsListRequestV5
 */
export interface CardActionsListRequestV5 {
    /**
     * 
     * @type {CardActionTypeV5}
     * @memberof CardActionsListRequestV5
     */
    'type'?: CardActionTypeV5;
    /**
     * Filter card actions which were initialized after given date. Greater or equal.
     * @type {string}
     * @memberof CardActionsListRequestV5
     */
    'actionInitializedAfterInclusive'?: string;
    /**
     * 
     * @type {CardActionStatusV5}
     * @memberof CardActionsListRequestV5
     * @deprecated
     */
    'status'?: CardActionStatusV5;
    /**
     * Filter card actions which have given error message. Like case insensitive.
     * @type {string}
     * @memberof CardActionsListRequestV5
     */
    'errorMessage'?: string;
    /**
     * Filter card actions which were processed after given date. Greater or equal.
     * @type {string}
     * @memberof CardActionsListRequestV5
     */
    'processedAfterInclusive'?: string;
    /**
     * Filter card actions which were started processing after given date. Greater or equal.
     * @type {string}
     * @memberof CardActionsListRequestV5
     */
    'startProcessAfterInclusive'?: string;
    /**
     * Filter card actions via request trace UUID. Equal.
     * @type {string}
     * @memberof CardActionsListRequestV5
     */
    'requestTraceUuid'?: string;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof CardActionsListRequestV5
     */
    'pageable': PageableV1x0;
}


/**
 * Response containing list of searched card actions.
 * @export
 * @interface CardActionsListResponse2V5
 */
export interface CardActionsListResponse2V5 {
    /**
     * 
     * @type {Array<CardActionItem2V5>}
     * @memberof CardActionsListResponse2V5
     */
    'cardActions': Array<CardActionItem2V5>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof CardActionsListResponse2V5
     */
    'pageable': PageableResponseV1x0;
}
/**
 * Response containing list of searched card actions.
 * @export
 * @interface CardActionsListResponseV5
 */
export interface CardActionsListResponseV5 {
    /**
     * 
     * @type {Array<CardActionItemV5>}
     * @memberof CardActionsListResponseV5
     */
    'cardActions': Array<CardActionItemV5>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof CardActionsListResponseV5
     */
    'pageable': PageableResponseV1x0;
}
/**
 * All actions that can be done with the card with boolean saying if the action can be performed or not.
 * @export
 * @interface CardActionsV7x0
 */
export interface CardActionsV7x0 {
    /**
     * True if card can be activated, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'activation': boolean;
    /**
     * True if card can be suspended/freeze, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'freeze': boolean;
    /**
     * True if card can be unsuspend/unfreeze, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'unfreeze': boolean;
    /**
     * True if card limit can be obtained, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'getLimit': boolean;
    /**
     * True if card limit can be changed, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'setLimit': boolean;
    /**
     * True if card can be terminated, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'termination': boolean;
    /**
     * True if card security ATM can be changed, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'setAtm': boolean;
    /**
     * True if card security CONTACTLESS can be changed, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'setContactless': boolean;
    /**
     * True if card security E_COMMERCE can be changed, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'setEcommerce': boolean;
    /**
     * True if card security MAG_STRIPE can be changed, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'setMagStripe': boolean;
    /**
     * True if card security DCC can be changed, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'setDcc': boolean;
    /**
     * True if card security MCC can be changed, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'setMcc': boolean;
    /**
     * True if card security BLOCK_SURCHARGE_FEE can be changed, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'setBlockSurchargeFee': boolean;
    /**
     * True if card pin can be unblocked, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'unblockPin': boolean;
    /**
     * True if card pin can be changed, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'changePin': boolean;
    /**
     * True if card pin can be shown, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'showPin': boolean;
    /**
     * True if card pan and cvv can be shown, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'showPanAndCvc': boolean;
    /**
     * True if card can be replaced, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'replacement': boolean;
    /**
     * True if FE can show add to wallet button, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'showWalletButton': boolean;
    /**
     * True if FE can show changing name of card, otherwise false.
     * @type {boolean}
     * @memberof CardActionsV7x0
     */
    'setCustomName': boolean;
}
/**
 * Card types. * PLASTIC - Standard card with plastic. * VIRTUAL - Virtual card without plastic. * VIRTUAL_ONETIME - Virtual card with one time usage (disposable). 
 * @export
 * @enum {string}
 */

export const CardCategoryV7x0 = {
    PLASTIC: 'PLASTIC',
    VIRTUAL: 'VIRTUAL',
    VIRTUAL_ONETIME: 'VIRTUAL_ONETIME'
} as const;

export type CardCategoryV7x0 = typeof CardCategoryV7x0[keyof typeof CardCategoryV7x0];


/**
 * 
 * @export
 * @interface CardCustomNameV5
 */
export interface CardCustomNameV5 {
    /**
     * 
     * @type {string}
     * @memberof CardCustomNameV5
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CardCustomNameV5
     */
    'bankCardUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CardCustomNameV5
     */
    'customCardName': string;
}
/**
 * Detail about the card.
 * @export
 * @interface CardDetailResponseV5
 */
export interface CardDetailResponseV5 {
    /**
     * UUID of the card.
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'bankCardUuid': string;
    /**
     * Masked PAN (card number).
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'pan': string;
    /**
     * Name of the card.
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'name': string;
    /**
     * 
     * @type {CardTypeV7x0}
     * @memberof CardDetailResponseV5
     */
    'type': CardTypeV7x0;
    /**
     * 
     * @type {CardCategoryV7x0}
     * @memberof CardDetailResponseV5
     */
    'category': CardCategoryV7x0;
    /**
     * 
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'designName'?: string;
    /**
     * 
     * @type {CardStatusV7x0}
     * @memberof CardDetailResponseV5
     */
    'status': CardStatusV7x0;
    /**
     * Active card suspends.
     * @type {Array<CardSuspendV7x0>}
     * @memberof CardDetailResponseV5
     */
    'suspends'?: Array<CardSuspendV7x0>;
    /**
     * 
     * @type {TerminationTypeV7x0}
     * @memberof CardDetailResponseV5
     */
    'terminationType'?: TerminationTypeV7x0;
    /**
     * Expiration of the card - until when the card is valid.
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'validTo': string;
    /**
     * 
     * @type {CardSecuritiesV7x0}
     * @memberof CardDetailResponseV5
     */
    'securities': CardSecuritiesV7x0;
    /**
     * 
     * @type {CardActionsV7x0}
     * @memberof CardDetailResponseV5
     */
    'actions': CardActionsV7x0;
    /**
     * 
     * @type {ReplacedCardInfoV7x0}
     * @memberof CardDetailResponseV5
     */
    'replacedBankCardUuid'?: ReplacedCardInfoV7x0;
    /**
     * 
     * @type {ReplacementCardInfoV7x0}
     * @memberof CardDetailResponseV5
     */
    'replacementBankCardUuid'?: ReplacementCardInfoV7x0;
    /**
     * True if card is expired, otherwise false.
     * @type {boolean}
     * @memberof CardDetailResponseV5
     */
    'expired': boolean;
    /**
     * True if card is blocked due to FAU/Police and customer doesn\'t know about it.
     * @type {boolean}
     * @memberof CardDetailResponseV5
     */
    'stealthBlocked': boolean;
    /**
     * Date when card was created.
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'creationDate': string;
    /**
     * Date when card was activated. If null, then card was not activated.
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'activationDate'?: string;
    /**
     * Date when card was frozen. If null, then card is in status ACTIVE, not SUSPENDED.
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'freezeDate'?: string;
    /**
     * Date when card was terminated. If card wasn\'t terminated, then it is null.
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'terminationDate'?: string;
    /**
     * Date when card was replaced. If card wasn\'t replaced, then it is null.
     * @type {string}
     * @memberof CardDetailResponseV5
     */
    'replacementDate'?: string;
    /**
     * 
     * @type {CardReplacementReasonV7x0}
     * @memberof CardDetailResponseV5
     */
    'replacementReason'?: CardReplacementReasonV7x0;
    /**
     * True if card delivery was express, otherwise false.
     * @type {boolean}
     * @memberof CardDetailResponseV5
     */
    'expressDelivery': boolean;
    /**
     * 
     * @type {UndeliveredCardDetailV5}
     * @memberof CardDetailResponseV5
     */
    'undeliveredCardDetail'?: UndeliveredCardDetailV5;
    /**
     * 
     * @type {DeliveryAddressV7x0}
     * @memberof CardDetailResponseV5
     */
    'deliveryAddress'?: DeliveryAddressV7x0;
    /**
     * List of custom names for the card.
     * @type {Array<CardCustomNameV5>}
     * @memberof CardDetailResponseV5
     */
    'cardCustomNames'?: Array<CardCustomNameV5>;
}


/**
 * Detail about the card with information about card limit.
 * @export
 * @interface CardDetailWithLimitResponseV5
 */
export interface CardDetailWithLimitResponseV5 {
    /**
     * 
     * @type {BackofficeAccountForCardListResponseV5}
     * @memberof CardDetailWithLimitResponseV5
     */
    'account': BackofficeAccountForCardListResponseV5;
    /**
     * 
     * @type {CardDetailResponseV5}
     * @memberof CardDetailWithLimitResponseV5
     */
    'card': CardDetailResponseV5;
    /**
     * 
     * @type {LimitV7x0}
     * @memberof CardDetailWithLimitResponseV5
     */
    'limit': LimitV7x0;
    /**
     * 
     * @type {AmountIsoCurrencyV2x0}
     * @memberof CardDetailWithLimitResponseV5
     */
    'maxLimitAmount': AmountIsoCurrencyV2x0;
    /**
     * 
     * @type {ClickToPayCardDetailV5}
     * @memberof CardDetailWithLimitResponseV5
     */
    'clickToPay': ClickToPayCardDetailV5;
}
/**
 * Card list item.
 * @export
 * @interface CardListItemV5
 */
export interface CardListItemV5 {
    /**
     * Unique identifier of the card.
     * @type {string}
     * @memberof CardListItemV5
     */
    'bankCardUuid': string;
    /**
     * Masked card number.
     * @type {string}
     * @memberof CardListItemV5
     */
    'pan': string;
    /**
     * Readable name of the card.
     * @type {string}
     * @memberof CardListItemV5
     */
    'name': string;
    /**
     * 
     * @type {CardTypeV7x0}
     * @memberof CardListItemV5
     */
    'type': CardTypeV7x0;
    /**
     * 
     * @type {string}
     * @memberof CardListItemV5
     */
    'designName'?: string;
    /**
     * 
     * @type {CardStatusV7x0}
     * @memberof CardListItemV5
     */
    'status': CardStatusV7x0;
    /**
     * Validation of the card.
     * @type {string}
     * @memberof CardListItemV5
     */
    'validTo': string;
    /**
     * Identifier for sensitive data operation eg. show/change pin or show full pan.
     * @type {string}
     * @memberof CardListItemV5
     */
    'sensitiveDataDistributionId': string;
    /**
     * True if card has blocked pin, otherwise false.
     * @type {boolean}
     * @memberof CardListItemV5
     */
    'pinBlocked': boolean;
    /**
     * 
     * @type {BackofficeAccountForCardListResponseV5}
     * @memberof CardListItemV5
     */
    'account': BackofficeAccountForCardListResponseV5;
}


/**
 * Reason why card is replaced. * DAMAGED - Damaged card. * LOST - Card is lost. * STOLEN - Card is stolen. 
 * @export
 * @enum {string}
 */

export const CardReplacementReasonV7x0 = {
    DAMAGED: 'DAMAGED',
    LOST: 'LOST',
    STOLEN: 'STOLEN'
} as const;

export type CardReplacementReasonV7x0 = typeof CardReplacementReasonV7x0[keyof typeof CardReplacementReasonV7x0];


/**
 * All card securities with information if security is enabled or disabled.
 * @export
 * @interface CardSecuritiesV7x0
 */
export interface CardSecuritiesV7x0 {
    /**
     * True if ATM security is enabled, otherwise false.
     * @type {boolean}
     * @memberof CardSecuritiesV7x0
     */
    'atm': boolean;
    /**
     * True if CONTACTLESS security is enabled, otherwise false.
     * @type {boolean}
     * @memberof CardSecuritiesV7x0
     */
    'contactless': boolean;
    /**
     * True if E_COMMERCE security is enabled, otherwise false.
     * @type {boolean}
     * @memberof CardSecuritiesV7x0
     */
    'ecommerce': boolean;
    /**
     * True if MAG_STRIPE security is enabled, otherwise false.
     * @type {boolean}
     * @memberof CardSecuritiesV7x0
     */
    'magStripe': boolean;
    /**
     * True if MCC security is enabled, otherwise false.
     * @type {boolean}
     * @memberof CardSecuritiesV7x0
     */
    'mcc': boolean;
    /**
     * True if DCC security is enabled, otherwise false.
     * @type {boolean}
     * @memberof CardSecuritiesV7x0
     */
    'dcc': boolean;
    /**
     * True if BLOCK_SURCHARGE_FEE security is enabled, otherwise false.
     * @type {boolean}
     * @memberof CardSecuritiesV7x0
     */
    'blockSurchargeFee': boolean;
}
/**
 * Status of the card. * UNACTIVATED - Card was sent to customer, waiting for activation. * ACTIVE - Card is in use by customer. * SUSPENDED - Card was temporarily blocked. Authorizations are declined. * TERMINATED - Card was manually terminated by user, renewed/replaced or expired. Card can\'t be use anymore. 
 * @export
 * @enum {string}
 */

export const CardStatusV7x0 = {
    UNACTIVATED: 'UNACTIVATED',
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    TERMINATED: 'TERMINATED'
} as const;

export type CardStatusV7x0 = typeof CardStatusV7x0[keyof typeof CardStatusV7x0];


/**
 * Card suspend.
 * @export
 * @interface CardSuspendV7x0
 */
export interface CardSuspendV7x0 {
    /**
     * 
     * @type {SuspendTypeV7x0}
     * @memberof CardSuspendV7x0
     */
    'suspendType': SuspendTypeV7x0;
    /**
     * Time suspend was created.
     * @type {string}
     * @memberof CardSuspendV7x0
     */
    'suspendFrom'?: string;
    /**
     * Time suspend was ended.
     * @type {string}
     * @memberof CardSuspendV7x0
     */
    'suspendTo'?: string;
    /**
     * Is suspend active.
     * @type {boolean}
     * @memberof CardSuspendV7x0
     */
    'valid': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CardTokenStatusV5 = {
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    INACTIVE: 'INACTIVE',
    DEACTIVATED: 'DEACTIVATED'
} as const;

export type CardTokenStatusV5 = typeof CardTokenStatusV5[keyof typeof CardTokenStatusV5];


/**
 * Card types. * VIRTUAL - Virtual card has no plastic, it exists just in application. * STANDARD - Standard plastic card. * PREMIUM - Plastic card for premium customers. * KIDS - Plastic card for kids, with various kid designs and limited rights. * COMMON - Plastic card for shared accounts. * DISPOSABLE - Virtual card which is after every card payment terminated. 
 * @export
 * @enum {string}
 */

export const CardTypeV7x0 = {
    VIRTUAL: 'VIRTUAL',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD',
    KIDS: 'KIDS',
    COMMON: 'COMMON',
    DISPOSABLE: 'DISPOSABLE'
} as const;

export type CardTypeV7x0 = typeof CardTypeV7x0[keyof typeof CardTypeV7x0];


/**
 * Request with card list filter, which uses OR logic for filter\'s fields and by default it is sorted DESC by card\'s creation date.
 * @export
 * @interface CardsListRequestV5
 */
export interface CardsListRequestV5 {
    /**
     * Unique identifier of the PID client
     * @type {string}
     * @memberof CardsListRequestV5
     */
    'pidUuid': string;
    /**
     * Filter cards via pidUuid of the card owner.
     * @type {string}
     * @memberof CardsListRequestV5
     */
    'ownerPidUuid'?: string;
    /**
     * Filter cards via pidUuid of the card holder.
     * @type {string}
     * @memberof CardsListRequestV5
     */
    'holderPidUuid'?: string;
    /**
     * Filter cards via uuid of the account related to the card.
     * @type {string}
     * @memberof CardsListRequestV5
     */
    'bankAccountUuid'?: string;
    /**
     * Filter cards which are in given status. If it is empty, then all statuses are returned.
     * @type {Array<CardStatusV7x0>}
     * @memberof CardsListRequestV5
     */
    'statuses'?: Array<CardStatusV7x0>;
    /**
     * 
     * @type {string}
     * @memberof CardsListRequestV5
     */
    'pan'?: string;
    /**
     * 
     * @type {SortV1x0}
     * @memberof CardsListRequestV5
     */
    'sort'?: SortV1x0;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof CardsListRequestV5
     */
    'pageable': PageableV1x0;
}
/**
 * Response containing list of searched cards.
 * @export
 * @interface CardsListResponseV5
 */
export interface CardsListResponseV5 {
    /**
     * 
     * @type {Array<CardListItemV5>}
     * @memberof CardsListResponseV5
     */
    'cards': Array<CardListItemV5>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof CardsListResponseV5
     */
    'pageable': PageableResponseV1x0;
}
/**
 * Detail about the card regarding Click to Pay functionality.
 * @export
 * @interface ClickToPayCardDetailV5
 */
export interface ClickToPayCardDetailV5 {
    /**
     * True if data successfully fetched, false otherwise.
     * @type {boolean}
     * @memberof ClickToPayCardDetailV5
     */
    'fetchResult': boolean;
    /**
     * UUID of the card.
     * @type {string}
     * @memberof ClickToPayCardDetailV5
     */
    'bankCardUuid'?: string;
    /**
     * Expiration date of the card.
     * @type {string}
     * @memberof ClickToPayCardDetailV5
     */
    'expirationDate'?: string;
    /**
     * Holder PID UUID.
     * @type {string}
     * @memberof ClickToPayCardDetailV5
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {CardStatusV7x0}
     * @memberof ClickToPayCardDetailV5
     */
    'status'?: CardStatusV7x0;
    /**
     * 
     * @type {CardTypeV7x0}
     * @memberof ClickToPayCardDetailV5
     */
    'type'?: CardTypeV7x0;
    /**
     * Masked PAN of the card.
     * @type {string}
     * @memberof ClickToPayCardDetailV5
     */
    'maskedPan'?: string;
    /**
     * 
     * @type {VisaCardStatusV5}
     * @memberof ClickToPayCardDetailV5
     */
    'visaStatus'?: VisaCardStatusV5;
    /**
     * 
     * @type {CustomerDetailV5}
     * @memberof ClickToPayCardDetailV5
     */
    'customerDetail'?: CustomerDetailV5;
    /**
     * Creation date of the card.
     * @type {string}
     * @memberof ClickToPayCardDetailV5
     */
    'createdAt'?: string;
    /**
     * Last update date of the card.
     * @type {string}
     * @memberof ClickToPayCardDetailV5
     */
    'updatedAt'?: string;
}


/**
 * Nationality, ISO 3166-1 format, subtype ALPHA-3. This means three letters in uppercase.
 * @export
 * @enum {string}
 */

export const CountryCodeV0x2 = {
    UNKNOWN: 'UNKNOWN',
    ABW: 'ABW',
    AFG: 'AFG',
    AGO: 'AGO',
    AIA: 'AIA',
    ALA: 'ALA',
    ALB: 'ALB',
    AND: 'AND',
    ARE: 'ARE',
    ARG: 'ARG',
    ARM: 'ARM',
    ASM: 'ASM',
    ATA: 'ATA',
    ATF: 'ATF',
    ATG: 'ATG',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BDI: 'BDI',
    BEL: 'BEL',
    BEN: 'BEN',
    BES: 'BES',
    BFA: 'BFA',
    BGD: 'BGD',
    BGR: 'BGR',
    BHR: 'BHR',
    BHS: 'BHS',
    BIH: 'BIH',
    BLM: 'BLM',
    BLR: 'BLR',
    BLZ: 'BLZ',
    BMU: 'BMU',
    BOL: 'BOL',
    BRA: 'BRA',
    BRB: 'BRB',
    BRN: 'BRN',
    BTN: 'BTN',
    BVT: 'BVT',
    BWA: 'BWA',
    CAF: 'CAF',
    CAN: 'CAN',
    CCK: 'CCK',
    CHE: 'CHE',
    CHL: 'CHL',
    CHN: 'CHN',
    CIV: 'CIV',
    CMR: 'CMR',
    COD: 'COD',
    COG: 'COG',
    COK: 'COK',
    COL: 'COL',
    COM: 'COM',
    CPV: 'CPV',
    CRI: 'CRI',
    CUB: 'CUB',
    CUW: 'CUW',
    CXR: 'CXR',
    CYM: 'CYM',
    CYP: 'CYP',
    CZE: 'CZE',
    DEU: 'DEU',
    DJI: 'DJI',
    DMA: 'DMA',
    DNK: 'DNK',
    DOM: 'DOM',
    DZA: 'DZA',
    ECU: 'ECU',
    EGY: 'EGY',
    ERI: 'ERI',
    ESH: 'ESH',
    ESP: 'ESP',
    EST: 'EST',
    ETH: 'ETH',
    FIN: 'FIN',
    FJI: 'FJI',
    FLK: 'FLK',
    FRA: 'FRA',
    FRO: 'FRO',
    FSM: 'FSM',
    GAB: 'GAB',
    GBR: 'GBR',
    GEO: 'GEO',
    GGY: 'GGY',
    GHA: 'GHA',
    GIB: 'GIB',
    GIN: 'GIN',
    GLP: 'GLP',
    GMB: 'GMB',
    GNB: 'GNB',
    GNQ: 'GNQ',
    GRC: 'GRC',
    GRD: 'GRD',
    GRL: 'GRL',
    GTM: 'GTM',
    GUF: 'GUF',
    GUM: 'GUM',
    GUY: 'GUY',
    HKG: 'HKG',
    HMD: 'HMD',
    HND: 'HND',
    HRV: 'HRV',
    HTI: 'HTI',
    HUN: 'HUN',
    IDN: 'IDN',
    IMN: 'IMN',
    IND: 'IND',
    IOT: 'IOT',
    IRL: 'IRL',
    IRN: 'IRN',
    IRQ: 'IRQ',
    ISL: 'ISL',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JEY: 'JEY',
    JOR: 'JOR',
    JPN: 'JPN',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KGZ: 'KGZ',
    KHM: 'KHM',
    KIR: 'KIR',
    KNA: 'KNA',
    KOR: 'KOR',
    KSV: 'KSV',
    KWT: 'KWT',
    LAO: 'LAO',
    LBN: 'LBN',
    LBR: 'LBR',
    LBY: 'LBY',
    LCA: 'LCA',
    LIE: 'LIE',
    LKA: 'LKA',
    LSO: 'LSO',
    LTU: 'LTU',
    LUX: 'LUX',
    LVA: 'LVA',
    MAC: 'MAC',
    MAF: 'MAF',
    MAR: 'MAR',
    MCO: 'MCO',
    MDA: 'MDA',
    MDG: 'MDG',
    MDV: 'MDV',
    MEX: 'MEX',
    MHL: 'MHL',
    MKD: 'MKD',
    MLI: 'MLI',
    MLT: 'MLT',
    MMR: 'MMR',
    MNE: 'MNE',
    MNG: 'MNG',
    MNP: 'MNP',
    MOZ: 'MOZ',
    MRT: 'MRT',
    MSR: 'MSR',
    MTQ: 'MTQ',
    MUS: 'MUS',
    MWI: 'MWI',
    MYS: 'MYS',
    MYT: 'MYT',
    NAM: 'NAM',
    NCL: 'NCL',
    NER: 'NER',
    NFK: 'NFK',
    NGA: 'NGA',
    NIC: 'NIC',
    NIU: 'NIU',
    NLD: 'NLD',
    NOR: 'NOR',
    NPL: 'NPL',
    NRU: 'NRU',
    NZL: 'NZL',
    OMN: 'OMN',
    PAK: 'PAK',
    PAN: 'PAN',
    PCN: 'PCN',
    PER: 'PER',
    PHL: 'PHL',
    PLW: 'PLW',
    PNG: 'PNG',
    POL: 'POL',
    PRI: 'PRI',
    PRK: 'PRK',
    PRT: 'PRT',
    PRY: 'PRY',
    PSE: 'PSE',
    PYF: 'PYF',
    QAT: 'QAT',
    REU: 'REU',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    SAU: 'SAU',
    SDN: 'SDN',
    SEN: 'SEN',
    SGP: 'SGP',
    SGS: 'SGS',
    SHN: 'SHN',
    SJM: 'SJM',
    SLB: 'SLB',
    SLE: 'SLE',
    SLV: 'SLV',
    SMR: 'SMR',
    SOM: 'SOM',
    SPM: 'SPM',
    SRB: 'SRB',
    SSD: 'SSD',
    STP: 'STP',
    SUR: 'SUR',
    SVK: 'SVK',
    SVN: 'SVN',
    SWE: 'SWE',
    SWZ: 'SWZ',
    SXM: 'SXM',
    SYC: 'SYC',
    SYR: 'SYR',
    TCA: 'TCA',
    TCD: 'TCD',
    TGO: 'TGO',
    THA: 'THA',
    TJK: 'TJK',
    TKL: 'TKL',
    TKM: 'TKM',
    TLS: 'TLS',
    TON: 'TON',
    TTO: 'TTO',
    TUN: 'TUN',
    TUR: 'TUR',
    TUV: 'TUV',
    TWN: 'TWN',
    TZA: 'TZA',
    UGA: 'UGA',
    UKR: 'UKR',
    UMI: 'UMI',
    URY: 'URY',
    USA: 'USA',
    UZB: 'UZB',
    VAT: 'VAT',
    VCT: 'VCT',
    VEN: 'VEN',
    VGB: 'VGB',
    VIR: 'VIR',
    VNM: 'VNM',
    VUT: 'VUT',
    WLF: 'WLF',
    WSM: 'WSM',
    YEM: 'YEM',
    ZAF: 'ZAF',
    ZMB: 'ZMB',
    ZWE: 'ZWE'
} as const;

export type CountryCodeV0x2 = typeof CountryCodeV0x2[keyof typeof CountryCodeV0x2];


/**
 * Detail about the card holder.
 * @export
 * @interface CustomerDetailV5
 */
export interface CustomerDetailV5 {
    /**
     * UUID of the card holder.
     * @type {string}
     * @memberof CustomerDetailV5
     */
    'pidUuid': string;
    /**
     * 
     * @type {AddressV5}
     * @memberof CustomerDetailV5
     */
    'address': AddressV5;
    /**
     * Phone number of the card holder.
     * @type {string}
     * @memberof CustomerDetailV5
     */
    'phone': string;
    /**
     * Email of the card holder.
     * @type {string}
     * @memberof CustomerDetailV5
     */
    'email': string;
    /**
     * First name of the card holder.
     * @type {string}
     * @memberof CustomerDetailV5
     */
    'firstName': string;
    /**
     * Last name of the card holder.
     * @type {string}
     * @memberof CustomerDetailV5
     */
    'lastName': string;
}
/**
 * Decline reason. Each reason is described below: - `MAX_INCORRECT_ATTEMPTS_COUNT_EXCEEDED`: The maximum number of incorrect attempts has been exceeded. - `MAX_ACTIVE_IOS_TOKENS_REACHED`: Max number of active tokens for iOS reached. - `MAX_ACTIVE_ANDROID_TOKENS_REACHED`: Max number of active tokens for Android reached. - `SUSPENDED_OR_TERMINATED_CARD`: Cannot be created for suspended or terminated card. - `FRAUD_SUSPICION_CASE_1`: Fraud suspicion case 1 from code 0G,0B,03,01,09. - `FRAUD_SUSPICION_CASE_2`: Fraud suspicion case 2 from code 0G,0B,03,01,0A. - `FRAUD_SUSPICION_CASE_3`: Fraud suspicion case 3 from code 0G,0B,03,04,09. - `FRAUD_SUSPICION_CASE_4`: Fraud suspicion case 4 from code 0G,0B,03,04,0A. - `FRAUD_SUSPICION_CASE_UNKNOWN`: Unknown fraud case code. - `INVALID_EXPIRATION_DATE`: User provided invalid expiration date. - `CVV2_FAILURE`: User provided invalid CVV2. - `UNKNOWN`: Unknown decline reason. - `INVALID_CARD_TYPE`: Unsupported card type (e.g. DISPOSABLE). - `REQUESTOR_NOT_SUPPORTED`: Token requestor is restricted (e.g. FIDESMO, SWATCH). - `MINIMAL_AGE`: Minimal age of cardholder not met. - `CHECK_ELIGIBILITY_INVALID_EXPIRATION_DATE`: Token was declined due to incorrect PAN during eligibility check. 
 * @export
 * @enum {string}
 */

export const DeclineReasonV5 = {
    MAX_INCORRECT_ATTEMPTS_COUNT_EXCEEDED: 'MAX_INCORRECT_ATTEMPTS_COUNT_EXCEEDED',
    MAX_ACTIVE_IOS_TOKENS_REACHED: 'MAX_ACTIVE_IOS_TOKENS_REACHED',
    MAX_ACTIVE_ANDROID_TOKENS_REACHED: 'MAX_ACTIVE_ANDROID_TOKENS_REACHED',
    SUSPENDED_OR_TERMINATED_CARD: 'SUSPENDED_OR_TERMINATED_CARD',
    FRAUD_SUSPICION_CASE_1: 'FRAUD_SUSPICION_CASE_1',
    FRAUD_SUSPICION_CASE_2: 'FRAUD_SUSPICION_CASE_2',
    FRAUD_SUSPICION_CASE_3: 'FRAUD_SUSPICION_CASE_3',
    FRAUD_SUSPICION_CASE_4: 'FRAUD_SUSPICION_CASE_4',
    FRAUD_SUSPICION_CASE_UNKNOWN: 'FRAUD_SUSPICION_CASE_UNKNOWN',
    INVALID_EXPIRATION_DATE: 'INVALID_EXPIRATION_DATE',
    CVV2_FAILURE: 'CVV2_FAILURE',
    UNKNOWN: 'UNKNOWN',
    INVALID_CARD_TYPE: 'INVALID_CARD_TYPE',
    REQUESTOR_NOT_SUPPORTED: 'REQUESTOR_NOT_SUPPORTED',
    MINIMAL_AGE: 'MINIMAL_AGE',
    CHECK_ELIGIBILITY_INVALID_EXPIRATION_DATE: 'CHECK_ELIGIBILITY_INVALID_EXPIRATION_DATE'
} as const;

export type DeclineReasonV5 = typeof DeclineReasonV5[keyof typeof DeclineReasonV5];


/**
 * Address
 * @export
 * @interface DeliveryAddressV7x0
 */
export interface DeliveryAddressV7x0 {
    /**
     * Name of the city
     * @type {string}
     * @memberof DeliveryAddressV7x0
     */
    'city': string;
    /**
     * Name of the city part.
     * @type {string}
     * @memberof DeliveryAddressV7x0
     */
    'cityPart'?: string;
    /**
     * Name of the street.
     * @type {string}
     * @memberof DeliveryAddressV7x0
     */
    'street'?: string;
    /**
     * House number.
     * @type {string}
     * @memberof DeliveryAddressV7x0
     */
    'houseNumber'?: string;
    /**
     * Street number.
     * @type {string}
     * @memberof DeliveryAddressV7x0
     */
    'streetNumber'?: string;
    /**
     * Evidence number.
     * @type {string}
     * @memberof DeliveryAddressV7x0
     */
    'evidenceNumber'?: string;
    /**
     * Building apartment.
     * @type {string}
     * @memberof DeliveryAddressV7x0
     */
    'buildingApartment'?: string;
    /**
     * Zipcode
     * @type {string}
     * @memberof DeliveryAddressV7x0
     */
    'zipcode': string;
    /**
     * 
     * @type {CountryCodeV0x2}
     * @memberof DeliveryAddressV7x0
     */
    'country': CountryCodeV0x2;
    /**
     * Ruian reference id.
     * @type {string}
     * @memberof DeliveryAddressV7x0
     */
    'ruianReference'?: string;
}


/**
 * 
 * @export
 * @interface DesignImageResponseV5
 */
export interface DesignImageResponseV5 {
    /**
     * 
     * @type {string}
     * @memberof DesignImageResponseV5
     */
    'svgImage': string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignImageResponseV5
     */
    'isDarkDesign': boolean;
}
/**
 * Side of the card design
 * @export
 * @enum {string}
 */

export const DesignSideV7x0 = {
    FRONT: 'FRONT',
    BACK: 'BACK'
} as const;

export type DesignSideV7x0 = typeof DesignSideV7x0[keyof typeof DesignSideV7x0];


/**
 * Device Type
 * @export
 * @enum {string}
 */

export const DeviceTypeV5 = {
    UNKNOWN: 'UNKNOWN',
    MOBILE_PHONE: 'MOBILE_PHONE',
    TABLET: 'TABLET',
    WATCH: 'WATCH',
    MOBILEPHONE_OR_TABLET: 'MOBILEPHONE_OR_TABLET',
    PC: 'PC',
    HOUSEHOLD_DEVICE: 'HOUSEHOLD_DEVICE',
    WEARABLE_DEVICE: 'WEARABLE_DEVICE',
    AUTOMOBILE_DEVICE: 'AUTOMOBILE_DEVICE'
} as const;

export type DeviceTypeV5 = typeof DeviceTypeV5[keyof typeof DeviceTypeV5];


/**
 * Response containing card limit.
 * @export
 * @interface GetCardLimitResponseV5
 */
export interface GetCardLimitResponseV5 {
    /**
     * 
     * @type {LimitV7x0}
     * @memberof GetCardLimitResponseV5
     */
    'limit': LimitV7x0;
    /**
     * 
     * @type {AmountIsoCurrencyV2x0}
     * @memberof GetCardLimitResponseV5
     */
    'maxAmount': AmountIsoCurrencyV2x0;
}
/**
 * Response containing list of card\'s tokens.
 * @export
 * @interface GetTokensListResponseV5
 */
export interface GetTokensListResponseV5 {
    /**
     * 
     * @type {Array<TokenDetailResponseV5>}
     * @memberof GetTokensListResponseV5
     */
    'tokens': Array<TokenDetailResponseV5>;
}
/**
 * Card daily limit
 * @export
 * @interface LimitV7x0
 */
export interface LimitV7x0 {
    /**
     * 
     * @type {AmountIsoCurrencyV2x0}
     * @memberof LimitV7x0
     */
    'amount': AmountIsoCurrencyV2x0;
    /**
     * 
     * @type {AmountIsoCurrencyV2x0}
     * @memberof LimitV7x0
     */
    'availableAmount': AmountIsoCurrencyV2x0;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OperationSystemTypeV5 = {
    IOS: 'IOS',
    ANDROID: 'ANDROID',
    OTHER: 'OTHER'
} as const;

export type OperationSystemTypeV5 = typeof OperationSystemTypeV5[keyof typeof OperationSystemTypeV5];


/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * Source of the PAN.
 * @export
 * @enum {string}
 */

export const PanSourceV5 = {
    KEY_ENTERED: 'KEY_ENTERED',
    ON_FILE: 'ON_FILE',
    MOBILE_BANKING_APP: 'MOBILE_BANKING_APP',
    CHIP_DIP: 'CHIP_DIP',
    CONTACTLESS_TAP: 'CONTACTLESS_TAP',
    TOKEN: 'TOKEN'
} as const;

export type PanSourceV5 = typeof PanSourceV5[keyof typeof PanSourceV5];


/**
 * 
 * @export
 * @interface ReplacedCardInfoV7x0
 */
export interface ReplacedCardInfoV7x0 {
    /**
     * UUID of the old (replaced) card.
     * @type {string}
     * @memberof ReplacedCardInfoV7x0
     */
    'bankCardUuid': string;
    /**
     * Masked PAN of the old (replaced) card.
     * @type {string}
     * @memberof ReplacedCardInfoV7x0
     */
    'pan': string;
}
/**
 * 
 * @export
 * @interface ReplacementCardInfoV7x0
 */
export interface ReplacementCardInfoV7x0 {
    /**
     * UUID of the new (replacement) card.
     * @type {string}
     * @memberof ReplacementCardInfoV7x0
     */
    'bankCardUuid': string;
    /**
     * Masked PAN of the new (replacement) card.
     * @type {string}
     * @memberof ReplacementCardInfoV7x0
     */
    'pan': string;
    /**
     * True if the new (replacement) card was already activated, otherwise false.
     * @type {boolean}
     * @memberof ReplacementCardInfoV7x0
     */
    'activated': boolean;
}
/**
 * Sorting order - ascendent or descendent.
 * @export
 * @enum {string}
 */

export const SortOrderTypeV1x0 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderTypeV1x0 = typeof SortOrderTypeV1x0[keyof typeof SortOrderTypeV1x0];


/**
 * Sort via given name and order type.
 * @export
 * @interface SortV1x0
 */
export interface SortV1x0 {
    /**
     * Name of the card field for sorting.
     * @type {string}
     * @memberof SortV1x0
     */
    'name': string;
    /**
     * 
     * @type {SortOrderTypeV1x0}
     * @memberof SortV1x0
     */
    'order': SortOrderTypeV1x0;
}


/**
 * Reason of the card suspension. * FRAUD - Card was suspended due to FRAUD transaction. * CLIENT - Card was suspended due to client\'s request. * EXT_CALLCENTER - Card was suspended due to external call center request. * BLOCKED - Card was suspended both for IN and OUT transactions due to Fraud Investigation. * INBLOCKED - Card was suspended for incoming transactions due to Fraud Investigation. * OUTBLOCKED - Card was suspended for outcoming transactions due to Fraud Investigation. * BO_CLIENT_ACCOUNT - Card was suspended by client\'s request to freeze the whole account. * UNKNOWN - Unknown suspend type. 
 * @export
 * @enum {string}
 */

export const SuspendTypeV7x0 = {
    FRAUD: 'FRAUD',
    CLIENT: 'CLIENT',
    EXTERNAL_CALLCENTER: 'EXTERNAL_CALLCENTER',
    BLOCKED: 'BLOCKED',
    INBLOCKED: 'INBLOCKED',
    OUTBLOCKED: 'OUTBLOCKED',
    BO_CLIENT_ACCOUNT: 'BO_CLIENT_ACCOUNT',
    UNKNOWN: 'UNKNOWN'
} as const;

export type SuspendTypeV7x0 = typeof SuspendTypeV7x0[keyof typeof SuspendTypeV7x0];


/**
 * Reason of the card termination. * CLIENT - Card terminated by client\'s request. * BANK - Card terminated by bank. * CLOSING_ACCOUNT - Card terminated by closing account. * DISPOSED - Disposable card terminated due to performed authorization. * EXPIRED - Card terminated due to expiration date. * REPLACED_DAMAGED - Card terminated due to replacement. Card was damaged. * REPLACED_LOST - Card terminated due to replacement. Card was lost. * REPLACED_STOLEN - Card terminated due to replacement. Card was stolen. * FRAUD - Card terminated due to fraud. * UNDELIVERED - Card terminated due to not being delivered to holder. * CHARGEBACK_FRAUD - Card terminated due to chargeback fraud. * ACCOUNT_TRANSITION - Card terminated due to account transition (e.g. child to adult). * UNKNOWN - Unknown termination type. 
 * @export
 * @enum {string}
 */

export const TerminationTypeV7x0 = {
    CLIENT: 'CLIENT',
    BANK: 'BANK',
    CLOSING_ACCOUNT: 'CLOSING_ACCOUNT',
    DISPOSED: 'DISPOSED',
    EXPIRED: 'EXPIRED',
    REPLACED_DAMAGED: 'REPLACED_DAMAGED',
    REPLACED_LOST: 'REPLACED_LOST',
    REPLACED_STOLEN: 'REPLACED_STOLEN',
    FRAUD: 'FRAUD',
    UNDELIVERED: 'UNDELIVERED',
    CHARGEBACK_FRAUD: 'CHARGEBACK_FRAUD',
    ACCOUNT_TRANSITION: 'ACCOUNT_TRANSITION',
    UNKNOWN: 'UNKNOWN'
} as const;

export type TerminationTypeV7x0 = typeof TerminationTypeV7x0[keyof typeof TerminationTypeV7x0];


/**
 * Detail of card token
 * @export
 * @interface TokenDetailResponseV5
 */
export interface TokenDetailResponseV5 {
    /**
     * Unique identifier of the card.
     * @type {string}
     * @memberof TokenDetailResponseV5
     */
    'bankCardUuid': string;
    /**
     * 
     * @type {string}
     * @memberof TokenDetailResponseV5
     */
    'panReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof TokenDetailResponseV5
     */
    'tokenReferenceId': string;
    /**
     * 
     * @type {CardTokenStatusV5}
     * @memberof TokenDetailResponseV5
     */
    'tokenStatus': CardTokenStatusV5;
    /**
     * 
     * @type {OperationSystemTypeV5}
     * @memberof TokenDetailResponseV5
     */
    'operationSystemType': OperationSystemTypeV5;
    /**
     * 
     * @type {PanSourceV5}
     * @memberof TokenDetailResponseV5
     */
    'panSource': PanSourceV5;
    /**
     * Device Id of source of token.
     * @type {string}
     * @memberof TokenDetailResponseV5
     */
    'deviceId'?: string;
    /**
     * 
     * @type {DeviceTypeV5}
     * @memberof TokenDetailResponseV5
     */
    'deviceType': DeviceTypeV5;
    /**
     * Name of source of token.
     * @type {string}
     * @memberof TokenDetailResponseV5
     */
    'deviceName': string;
    /**
     * Date when token was activated.
     * @type {string}
     * @memberof TokenDetailResponseV5
     */
    'tokenActivateDate'?: string;
    /**
     * Date when token was created.
     * @type {string}
     * @memberof TokenDetailResponseV5
     */
    'createdAt'?: string;
    /**
     * Date when token was suspended.
     * @type {string}
     * @memberof TokenDetailResponseV5
     */
    'suspendedDate'?: string;
    /**
     * Date when token was deleted-terminated.
     * @type {string}
     * @memberof TokenDetailResponseV5
     */
    'terminatedDate'?: string;
    /**
     * 
     * @type {DeclineReasonV5}
     * @memberof TokenDetailResponseV5
     */
    'declineReason'?: DeclineReasonV5;
    /**
     * Step up methods allowed for activation.
     * @type {Array<TokenStepUpMethodV5>}
     * @memberof TokenDetailResponseV5
     */
    'stepUpMethods'?: Array<TokenStepUpMethodV5>;
    /**
     * 
     * @type {VerificationTypeV5}
     * @memberof TokenDetailResponseV5
     */
    'verificationType'?: VerificationTypeV5;
}


/**
 * Method used for step up authentication. - `UNKNOWN`: Only in case of unknown option or parsing error. 
 * @export
 * @enum {string}
 */

export const TokenStepUpMethodV5 = {
    OTP_SMS: 'OTP_SMS',
    OTP_EMAIL: 'OTP_EMAIL',
    APP_TO_APP: 'APP_TO_APP',
    CUSTOMER_SERVICE: 'CUSTOMER_SERVICE',
    OUTBOUND_CALL: 'OUTBOUND_CALL',
    UNKNOWN: 'UNKNOWN'
} as const;

export type TokenStepUpMethodV5 = typeof TokenStepUpMethodV5[keyof typeof TokenStepUpMethodV5];


/**
 * 
 * @export
 * @interface UndeliveredCardDetailV5
 */
export interface UndeliveredCardDetailV5 {
    /**
     * 
     * @type {string}
     * @memberof UndeliveredCardDetailV5
     */
    'returnedDate': string;
    /**
     * 
     * @type {UndeliveredCardReturnedCodeV5}
     * @memberof UndeliveredCardDetailV5
     */
    'returnedCode': UndeliveredCardReturnedCodeV5;
}


/**
 * UNDELIVERED = Nepřijato UNCLAIMED = Nevyzvednuto CUSTOMER_HAS_MOVED = Zákazník se odstěhoval UNKNOWN_CUSTOMER = Na uvedené adrese neznámý INSUFFICIENT_ADDRESS = Adresa nedostatečná OTHER_REASON = Jiný důvod CUSTOMER_HAS_DIED = Adresát zemřel 
 * @export
 * @enum {string}
 */

export const UndeliveredCardReturnedCodeV5 = {
    UNDELIVERED: 'UNDELIVERED',
    UNCLAIMED: 'UNCLAIMED',
    CUSTOMER_HAS_MOVED: 'CUSTOMER_HAS_MOVED',
    UNKNOWN_CUSTOMER: 'UNKNOWN_CUSTOMER',
    INSUFFICIENT_ADDRESS: 'INSUFFICIENT_ADDRESS',
    OTHER_REASON: 'OTHER_REASON',
    CUSTOMER_HAS_DIED: 'CUSTOMER_HAS_DIED'
} as const;

export type UndeliveredCardReturnedCodeV5 = typeof UndeliveredCardReturnedCodeV5[keyof typeof UndeliveredCardReturnedCodeV5];


/**
 * Verification types of token. 
 * @export
 * @enum {string}
 */

export const VerificationTypeV5 = {
    OTP: 'OTP',
    MOBILE_BANK_APP: 'MOBILE_BANK_APP',
    CALL_CENTER: 'CALL_CENTER',
    DEVICE_PROVISIONING_RESULT: 'DEVICE_PROVISIONING_RESULT'
} as const;

export type VerificationTypeV5 = typeof VerificationTypeV5[keyof typeof VerificationTypeV5];


/**
 * Status of the card in VISA:  - `ACTIVATING` - card is being activated  - `ACTIVE` - card is active  - `DISABLING` - card is being disabled  - `DISABLED` - card is disabled 
 * @export
 * @enum {string}
 */

export const VisaCardStatusV5 = {
    ACTIVATING: 'ACTIVATING',
    ACTIVE: 'ACTIVE',
    DISABLING: 'DISABLING',
    DISABLED: 'DISABLED'
} as const;

export type VisaCardStatusV5 = typeof VisaCardStatusV5[keyof typeof VisaCardStatusV5];




/**
 * CardsApi - axios parameter creator
 * @export
 */
export const CardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Freeze card - it will switch tu SUSPENDED status, where all outgoing payments are blocked.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeCardV5: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('freezeCardV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('freezeCardV5', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('freezeCardV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/cards/{bankCardUuid}/freeze`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all card actions filtered by filter in the request.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {CardActionsListRequest2V5} cardActionsListRequest2V5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardActionsList2V5: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, cardActionsListRequest2V5: CardActionsListRequest2V5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getCardActionsList2V5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('getCardActionsList2V5', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('getCardActionsList2V5', 'clientPidUuid', clientPidUuid)
            // verify required parameter 'cardActionsListRequest2V5' is not null or undefined
            assertParamExists('getCardActionsList2V5', 'cardActionsListRequest2V5', cardActionsListRequest2V5)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/cards/{bankCardUuid}/actions2`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardActionsListRequest2V5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, use actions2. Get all card actions filtered by filter in the request. 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {CardActionsListRequestV5} cardActionsListRequestV5 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCardActionsListV5: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, cardActionsListRequestV5: CardActionsListRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getCardActionsListV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('getCardActionsListV5', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('getCardActionsListV5', 'clientPidUuid', clientPidUuid)
            // verify required parameter 'cardActionsListRequestV5' is not null or undefined
            assertParamExists('getCardActionsListV5', 'cardActionsListRequestV5', cardActionsListRequestV5)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/cards/{bankCardUuid}/actions`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardActionsListRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detail of the card.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardDetailV5: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getCardDetailV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('getCardDetailV5', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('getCardDetailV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/cards/{bankCardUuid}`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get card\'s current daily limit.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardLimitV5: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getCardLimitV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('getCardLimitV5', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('getCardLimitV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/cards/{bankCardUuid}/limit`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all cards filtered by filter in the request.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {CardsListRequestV5} cardsListRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsListV5: async (xCorrelationId: string, cardsListRequestV5: CardsListRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getCardsListV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'cardsListRequestV5' is not null or undefined
            assertParamExists('getCardsListV5', 'cardsListRequestV5', cardsListRequestV5)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/cards/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardsListRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unfreeze the frozen card. It will switch back to ACTIVE status and outgoing payments will be unblocked.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfreezeCardV5: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('unfreezeCardV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('unfreezeCardV5', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('unfreezeCardV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/cards/{bankCardUuid}/unfreeze`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardsApi - functional programming interface
 * @export
 */
export const CardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardsApiAxiosParamCreator(configuration)
    return {
        /**
         * Freeze card - it will switch tu SUSPENDED status, where all outgoing payments are blocked.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freezeCardV5(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freezeCardV5(xCorrelationId, bankCardUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all card actions filtered by filter in the request.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {CardActionsListRequest2V5} cardActionsListRequest2V5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardActionsList2V5(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, cardActionsListRequest2V5: CardActionsListRequest2V5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardActionsListResponse2V5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardActionsList2V5(xCorrelationId, bankCardUuid, clientPidUuid, cardActionsListRequest2V5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, use actions2. Get all card actions filtered by filter in the request. 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {CardActionsListRequestV5} cardActionsListRequestV5 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getCardActionsListV5(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, cardActionsListRequestV5: CardActionsListRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardActionsListResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardActionsListV5(xCorrelationId, bankCardUuid, clientPidUuid, cardActionsListRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get detail of the card.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardDetailV5(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardDetailWithLimitResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardDetailV5(xCorrelationId, bankCardUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get card\'s current daily limit.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardLimitV5(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardLimitResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardLimitV5(xCorrelationId, bankCardUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all cards filtered by filter in the request.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {CardsListRequestV5} cardsListRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardsListV5(xCorrelationId: string, cardsListRequestV5: CardsListRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardsListResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardsListV5(xCorrelationId, cardsListRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unfreeze the frozen card. It will switch back to ACTIVE status and outgoing payments will be unblocked.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unfreezeCardV5(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unfreezeCardV5(xCorrelationId, bankCardUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CardsApi - factory interface
 * @export
 */
export const CardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardsApiFp(configuration)
    return {
        /**
         * Freeze card - it will switch tu SUSPENDED status, where all outgoing payments are blocked.
         * @param {CardsApiFreezeCardV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeCardV5(requestParameters: CardsApiFreezeCardV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.freezeCardV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get all card actions filtered by filter in the request.
         * @param {CardsApiGetCardActionsList2V5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardActionsList2V5(requestParameters: CardsApiGetCardActionsList2V5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<CardActionsListResponse2V5> {
            return localVarFp.getCardActionsList2V5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, requestParameters.cardActionsListRequest2V5, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, use actions2. Get all card actions filtered by filter in the request. 
         * @param {CardsApiGetCardActionsListV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCardActionsListV5(requestParameters: CardsApiGetCardActionsListV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<CardActionsListResponseV5> {
            return localVarFp.getCardActionsListV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, requestParameters.cardActionsListRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get detail of the card.
         * @param {CardsApiGetCardDetailV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardDetailV5(requestParameters: CardsApiGetCardDetailV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<CardDetailWithLimitResponseV5> {
            return localVarFp.getCardDetailV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get card\'s current daily limit.
         * @param {CardsApiGetCardLimitV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardLimitV5(requestParameters: CardsApiGetCardLimitV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GetCardLimitResponseV5> {
            return localVarFp.getCardLimitV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get all cards filtered by filter in the request.
         * @param {CardsApiGetCardsListV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsListV5(requestParameters: CardsApiGetCardsListV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<CardsListResponseV5> {
            return localVarFp.getCardsListV5(requestParameters.xCorrelationId, requestParameters.cardsListRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Unfreeze the frozen card. It will switch back to ACTIVE status and outgoing payments will be unblocked.
         * @param {CardsApiUnfreezeCardV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfreezeCardV5(requestParameters: CardsApiUnfreezeCardV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.unfreezeCardV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for freezeCardV5 operation in CardsApi.
 * @export
 * @type CardsApiFreezeCardV5Request
 */
export type CardsApiFreezeCardV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiFreezeCardV5
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiFreezeCardV5
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiFreezeCardV5
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for getCardActionsList2V5 operation in CardsApi.
 * @export
 * @type CardsApiGetCardActionsList2V5Request
 */
export type CardsApiGetCardActionsList2V5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiGetCardActionsList2V5
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiGetCardActionsList2V5
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiGetCardActionsList2V5
     */
    readonly clientPidUuid: string

    /**
     * 
     * @type {CardActionsListRequest2V5}
     * @memberof CardsApiGetCardActionsList2V5
     */
    readonly cardActionsListRequest2V5: CardActionsListRequest2V5
}

/**
 * Request parameters for getCardActionsListV5 operation in CardsApi.
 * @export
 * @type CardsApiGetCardActionsListV5Request
 */
export type CardsApiGetCardActionsListV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiGetCardActionsListV5
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiGetCardActionsListV5
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiGetCardActionsListV5
     */
    readonly clientPidUuid: string

    /**
     * 
     * @type {CardActionsListRequestV5}
     * @memberof CardsApiGetCardActionsListV5
     */
    readonly cardActionsListRequestV5: CardActionsListRequestV5
}

/**
 * Request parameters for getCardDetailV5 operation in CardsApi.
 * @export
 * @type CardsApiGetCardDetailV5Request
 */
export type CardsApiGetCardDetailV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiGetCardDetailV5
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiGetCardDetailV5
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiGetCardDetailV5
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for getCardLimitV5 operation in CardsApi.
 * @export
 * @type CardsApiGetCardLimitV5Request
 */
export type CardsApiGetCardLimitV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiGetCardLimitV5
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiGetCardLimitV5
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiGetCardLimitV5
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for getCardsListV5 operation in CardsApi.
 * @export
 * @type CardsApiGetCardsListV5Request
 */
export type CardsApiGetCardsListV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiGetCardsListV5
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {CardsListRequestV5}
     * @memberof CardsApiGetCardsListV5
     */
    readonly cardsListRequestV5: CardsListRequestV5
}

/**
 * Request parameters for unfreezeCardV5 operation in CardsApi.
 * @export
 * @type CardsApiUnfreezeCardV5Request
 */
export type CardsApiUnfreezeCardV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiUnfreezeCardV5
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiUnfreezeCardV5
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiUnfreezeCardV5
     */
    readonly clientPidUuid: string
}

/**
 * CardsApi - object-oriented interface
 * @export
 * @class CardsApi
 * @extends {BaseAPI}
 */
export class CardsApi extends BaseAPI {
    /**
     * Freeze card - it will switch tu SUSPENDED status, where all outgoing payments are blocked.
     * @param {CardsApiFreezeCardV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public freezeCardV5(requestParameters: CardsApiFreezeCardV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).freezeCardV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all card actions filtered by filter in the request.
     * @param {CardsApiGetCardActionsList2V5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public getCardActionsList2V5(requestParameters: CardsApiGetCardActionsList2V5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).getCardActionsList2V5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, requestParameters.cardActionsListRequest2V5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, use actions2. Get all card actions filtered by filter in the request. 
     * @param {CardsApiGetCardActionsListV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public getCardActionsListV5(requestParameters: CardsApiGetCardActionsListV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).getCardActionsListV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, requestParameters.cardActionsListRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detail of the card.
     * @param {CardsApiGetCardDetailV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public getCardDetailV5(requestParameters: CardsApiGetCardDetailV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).getCardDetailV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get card\'s current daily limit.
     * @param {CardsApiGetCardLimitV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public getCardLimitV5(requestParameters: CardsApiGetCardLimitV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).getCardLimitV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all cards filtered by filter in the request.
     * @param {CardsApiGetCardsListV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public getCardsListV5(requestParameters: CardsApiGetCardsListV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).getCardsListV5(requestParameters.xCorrelationId, requestParameters.cardsListRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unfreeze the frozen card. It will switch back to ACTIVE status and outgoing payments will be unblocked.
     * @param {CardsApiUnfreezeCardV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public unfreezeCardV5(requestParameters: CardsApiUnfreezeCardV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).unfreezeCardV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DesignsApi - axios parameter creator
 * @export
 */
export const DesignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get SVG image of the given card design and card side. Design is cached in Hazelcast. At first we try to get image from Hazelcast, if it is not found, then it is downloaded from Minio. 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} designName 
         * @param {DesignSideV7x0} designSide 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignImageV5: async (xCorrelationId: string, designName: string, designSide: DesignSideV7x0, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getDesignImageV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'designName' is not null or undefined
            assertParamExists('getDesignImageV5', 'designName', designName)
            // verify required parameter 'designSide' is not null or undefined
            assertParamExists('getDesignImageV5', 'designSide', designSide)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/designs/{designName}/images/{designSide}`
                .replace(`{${"designName"}}`, encodeURIComponent(String(designName)))
                .replace(`{${"designSide"}}`, encodeURIComponent(String(designSide)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DesignsApi - functional programming interface
 * @export
 */
export const DesignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DesignsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get SVG image of the given card design and card side. Design is cached in Hazelcast. At first we try to get image from Hazelcast, if it is not found, then it is downloaded from Minio. 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} designName 
         * @param {DesignSideV7x0} designSide 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignImageV5(xCorrelationId: string, designName: string, designSide: DesignSideV7x0, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignImageResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignImageV5(xCorrelationId, designName, designSide, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DesignsApi - factory interface
 * @export
 */
export const DesignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DesignsApiFp(configuration)
    return {
        /**
         * Get SVG image of the given card design and card side. Design is cached in Hazelcast. At first we try to get image from Hazelcast, if it is not found, then it is downloaded from Minio. 
         * @param {DesignsApiGetDesignImageV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignImageV5(requestParameters: DesignsApiGetDesignImageV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<DesignImageResponseV5> {
            return localVarFp.getDesignImageV5(requestParameters.xCorrelationId, requestParameters.designName, requestParameters.designSide, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDesignImageV5 operation in DesignsApi.
 * @export
 * @type DesignsApiGetDesignImageV5Request
 */
export type DesignsApiGetDesignImageV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof DesignsApiGetDesignImageV5
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof DesignsApiGetDesignImageV5
     */
    readonly designName: string

    /**
     * 
     * @type {DesignSideV7x0}
     * @memberof DesignsApiGetDesignImageV5
     */
    readonly designSide: DesignSideV7x0
}

/**
 * DesignsApi - object-oriented interface
 * @export
 * @class DesignsApi
 * @extends {BaseAPI}
 */
export class DesignsApi extends BaseAPI {
    /**
     * Get SVG image of the given card design and card side. Design is cached in Hazelcast. At first we try to get image from Hazelcast, if it is not found, then it is downloaded from Minio. 
     * @param {DesignsApiGetDesignImageV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignsApi
     */
    public getDesignImageV5(requestParameters: DesignsApiGetDesignImageV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return DesignsApiFp(this.configuration).getDesignImageV5(requestParameters.xCorrelationId, requestParameters.designName, requestParameters.designSide, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TokensApi - axios parameter creator
 * @export
 */
export const TokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all tokens for the card.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardTokenListV5: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('cardTokenListV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('cardTokenListV5', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('cardTokenListV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/tokens/{bankCardUuid}/list`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Freeze token via backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} tokenReferenceId unique reference to visa token
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenFreezeV5: async (xCorrelationId: string, tokenReferenceId: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('tokenFreezeV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'tokenReferenceId' is not null or undefined
            assertParamExists('tokenFreezeV5', 'tokenReferenceId', tokenReferenceId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('tokenFreezeV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/tokens/{tokenReferenceId}/freeze`
                .replace(`{${"tokenReferenceId"}}`, encodeURIComponent(String(tokenReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unfreeze token via backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} tokenReferenceId unique reference to visa token
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenUnfreezeV5: async (xCorrelationId: string, tokenReferenceId: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('tokenUnfreezeV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'tokenReferenceId' is not null or undefined
            assertParamExists('tokenUnfreezeV5', 'tokenReferenceId', tokenReferenceId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('tokenUnfreezeV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards-external/v5/tokens/{tokenReferenceId}/unfreeze`
                .replace(`{${"tokenReferenceId"}}`, encodeURIComponent(String(tokenReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokensApi - functional programming interface
 * @export
 */
export const TokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokensApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all tokens for the card.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardTokenListV5(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTokensListResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardTokenListV5(xCorrelationId, bankCardUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Freeze token via backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} tokenReferenceId unique reference to visa token
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenFreezeV5(xCorrelationId: string, tokenReferenceId: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenFreezeV5(xCorrelationId, tokenReferenceId, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unfreeze token via backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} tokenReferenceId unique reference to visa token
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenUnfreezeV5(xCorrelationId: string, tokenReferenceId: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenUnfreezeV5(xCorrelationId, tokenReferenceId, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokensApi - factory interface
 * @export
 */
export const TokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokensApiFp(configuration)
    return {
        /**
         * Get all tokens for the card.
         * @param {TokensApiCardTokenListV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardTokenListV5(requestParameters: TokensApiCardTokenListV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GetTokensListResponseV5> {
            return localVarFp.cardTokenListV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Freeze token via backoffice.
         * @param {TokensApiTokenFreezeV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenFreezeV5(requestParameters: TokensApiTokenFreezeV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.tokenFreezeV5(requestParameters.xCorrelationId, requestParameters.tokenReferenceId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Unfreeze token via backoffice.
         * @param {TokensApiTokenUnfreezeV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenUnfreezeV5(requestParameters: TokensApiTokenUnfreezeV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.tokenUnfreezeV5(requestParameters.xCorrelationId, requestParameters.tokenReferenceId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cardTokenListV5 operation in TokensApi.
 * @export
 * @type TokensApiCardTokenListV5Request
 */
export type TokensApiCardTokenListV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof TokensApiCardTokenListV5
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof TokensApiCardTokenListV5
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof TokensApiCardTokenListV5
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for tokenFreezeV5 operation in TokensApi.
 * @export
 * @type TokensApiTokenFreezeV5Request
 */
export type TokensApiTokenFreezeV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof TokensApiTokenFreezeV5
     */
    readonly xCorrelationId: string

    /**
     * unique reference to visa token
     * @type {string}
     * @memberof TokensApiTokenFreezeV5
     */
    readonly tokenReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof TokensApiTokenFreezeV5
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for tokenUnfreezeV5 operation in TokensApi.
 * @export
 * @type TokensApiTokenUnfreezeV5Request
 */
export type TokensApiTokenUnfreezeV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof TokensApiTokenUnfreezeV5
     */
    readonly xCorrelationId: string

    /**
     * unique reference to visa token
     * @type {string}
     * @memberof TokensApiTokenUnfreezeV5
     */
    readonly tokenReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof TokensApiTokenUnfreezeV5
     */
    readonly clientPidUuid: string
}

/**
 * TokensApi - object-oriented interface
 * @export
 * @class TokensApi
 * @extends {BaseAPI}
 */
export class TokensApi extends BaseAPI {
    /**
     * Get all tokens for the card.
     * @param {TokensApiCardTokenListV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public cardTokenListV5(requestParameters: TokensApiCardTokenListV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return TokensApiFp(this.configuration).cardTokenListV5(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Freeze token via backoffice.
     * @param {TokensApiTokenFreezeV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public tokenFreezeV5(requestParameters: TokensApiTokenFreezeV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return TokensApiFp(this.configuration).tokenFreezeV5(requestParameters.xCorrelationId, requestParameters.tokenReferenceId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unfreeze token via backoffice.
     * @param {TokensApiTokenUnfreezeV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public tokenUnfreezeV5(requestParameters: TokensApiTokenUnfreezeV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return TokensApiFp(this.configuration).tokenUnfreezeV5(requestParameters.xCorrelationId, requestParameters.tokenReferenceId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


